import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";

@Component({
    selector: "app-input-text",
    templateUrl: "./input-text.component.html",
    styleUrls: ["./input-text.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputTextComponent implements AfterViewInit {
  /**
   * Text that should be displayed above the input
   */
  @Input() label: String = "";

  /**
   * Error message
   */
  @Input() errorText: String = "";

  /**
   * Placeholder
   */
  @Input() placeholder: String = "";

  /**
   * Input type
   */
  @Input() type = "text";

  /**
   * Sets the input to required
   */
  @Input() required = false;

  /**
   * changes the input to valid/invalid
   */
  @Input() invalid: boolean = true;

  /**
   * Sets the classes directly
   */
  @Input() classes = "";

  /**
   * Begrenzt die Nachkommastellen im Feld selbst (2 fuer Geldbetraege)
   */
  @Input() maxDecimals: number | null = null;

  /**
   * Untere und obere Grenze fuer type="number"
   */
  @Input() min: number | null = null;

  @Input() max: number | null = null;

  /**
   * Fokussiert das Feld, sobald es gerendert ist — fuer den Hauptinput einer Seite
   */
  @Input() autoFocus = false;

  /**
   * main output
   */
  @Output() currentValue: EventEmitter<String> = new EventEmitter<String>();

  /**
   * Von aussen setzbar, damit z. B. ein "Gesamtbetrag"-Button das Feld
   * füllen kann. Ohne das bleibt die Anzeige stehen.
   */
  @Input() value: String = "";

  @ViewChild("field") private _field?: ElementRef<HTMLInputElement>;

  public ngAfterViewInit(): void {
    if (this.autoFocus) {
      this._field?.nativeElement.focus();
    }
  }

  public valueChanged() {
    this.clampDecimals();
    this.currentValue.emit(this.value);
  }

  /**
   * Schneidet ueberzaehlige Nachkommastellen ab
   */
  private clampDecimals(): void {
    if (this.maxDecimals === null) {
      return;
    }

    const parts = String(this.value ?? "").split(/[.,]/);

    if (parts.length !== 2 || parts[1].length <= this.maxDecimals) {
      return;
    }

    this.value = `${parts[0]}.${parts[1].slice(0, this.maxDecimals)}`;

    // ⚠ Direkt ins DOM — das Binding traegt denselben Wert wie zuvor, Angular
    // erkennt keine Aenderung und wuerde die getippten Ziffern stehen lassen.
    if (this._field) {
      this._field.nativeElement.value = String(this.value);
    }
  }
}
